/**
 * The data-grid cell entries for part support requests (list view and single views)
 */
export const PartSupportRequestsDataGridCellKeys = {
    navigate: 'navigate' as const,
    rga: 'rga' as const,
    type: 'type' as const,
    status: 'status' as const,
    vendorStatus: 'vendorStatus' as const,
    reason: 'changeStatusReason' as const,
    partNo: 'part' as const,
    credit: 'credit' as const,
    user: 'user' as const,
    submitDateTime: 'submitDate' as const,
    customer: 'customer' as const,
    warehouseCode: 'warehouseCode' as const,
    invoiceNo: 'invoiceNo' as const,
    serialNo: 'serialNo' as const,
    count: 'Count' as const,
    operator: 'Operator' as const,
    open: 'open' as const,
    vendor: 'vendor' as const,
    note: 'note' as const,
    internalNote: 'internalNote' as const,
    vendorCredit: 'vendorCredit' as const,
    make: 'make' as const,
    model: 'model' as const,
    year: 'year' as const,
    vin: 'vin' as const,
    installedDate: 'installedDate' as const,
    failedDate: 'failedDate' as const,
    installedMileage: 'installedMileage' as const,
    failedMileage: 'failedMileage' as const,
    remarks: 'remarks' as const,
    print: 'print' as const,
}

/**
 * The data-grid cell entries for actions lists of ncr (single views)
 */
export const NCRActionsDataGridCellKeys = {
    actionOwner: 'actionOwner',
    assignee: 'assignee',
    title: 'title',
    edit: 'edit',
    completionDate: 'completionDate',
    targetCompletionDate: 'targetCompletionDate',
    status: 'status',
    description: 'description',
};

/**
 * The data-grid cell entries for Notes lists of ncr (notes page)
 */
export const NCRNotesDataGridCellKeys = {
    navigate: 'navigate',
    submittedByName: 'submittedByName',
    title: 'title',
    ncrCode: 'ncrCode',
    submitDate: 'submitDate',
    content: 'content',
};

/**
 * The data-grid cell entries for customer notes list view.
 */
export const CustomerNotesDataGridCellKeys = {
    navigate: 'navigate',
    submittedByName: 'submittedByName',
    title: 'title',
    source: 'source',
    visibility: 'visibility',
    submitDate: 'submitDate',
    content: 'content',
};

/**
 * The data-grid cell entries for vendor notes list view.
 */
export const VendorNotesDataGridCellKeys = {
    navigate: 'navigate',
    submittedByName: 'submittedByName',
    title: 'title',
    source: 'source',
    visibility: 'visibility',
    submitDate: 'submitDate',
    content: 'content',
};

/**
 * The data-grid cell entries for quotes view's orders list.
 */
export const QuotesListsOrdersDataGridCellKeys = {
    navigate: 'navigate' as const,
    print: 'print' as const,
    orderNo: "orderNo" as const,
    customer: "customer" as const,
    orderDate: "orderDate" as const,
    customerPO: "customerPO" as const,
    salespersonNo: "salespersonNo" as const,
    totalOrdered: "totalOrdered" as const,
    status: "status" as const,
}

/**
 * The data-grid cell entries for quotes view's items list.
 */
export const QuotesListsItemsDataGridCellKeys = {
    navigate: 'navigate' as const,
    print: 'print' as const,
    orderNo: "orderNo" as const,
    customer: "customer" as const,
    partNo: "partNo" as const,
    submitDate: "submitDate" as const,
    unitPrice: "unitPrice" as const,
    orderQty: "orderQty" as const,
}

/**
 * The data-grid cell entries for sales orders view's orders list.
 */
export const SalesOrdersListsOrdersDataGridCellKeys = {
    navigate: 'navigate' as const,
    print: 'print' as const,
    revertToQuote: 'revertToQuote' as const,
    orderNo: "orderNo" as const,
    customer: "customer" as const,
    orderDate: "orderDate" as const,
    customerPO: "customerPO" as const,
    salespersonNo: "salespersonNo" as const,
    totalOrdered: "totalOrdered" as const,
}

/**
 * The data-grid cell entries for sales orders view's items list.
 */
export const SalesOrdersListsItemsDataGridCellKeys = {
    navigate: 'navigate' as const,
    print: 'print' as const,
    orderNo: "orderNo" as const,
    customer: "customer" as const,
    partNo: "partNo" as const,
    submitDate: "submitDate" as const,
    unitPrice: "unitPrice" as const,
    orderQty: "orderQty" as const,
    shipQty: "shipQty" as const,
    backorderQty: "backorderQty" as const,
    committedQty: "committedQty" as const,
    revertToQuote: "revertToQuote" as const,
}

/**
 * The data-grid cell entries for back orders view's orders list.
 */
export const BackOrdersListsOrdersDataGridCellKeys = {
    navigate: 'navigate' as const,
    print: 'print' as const,
    revertToQuote: 'revertToQuote' as const,
    orderNo: "orderNo" as const,
    invoiceNo: 'invoiceNo' as const,
    customer: "customer" as const,
    orderDate: "orderDate" as const,
    customerPO: "customerPO" as const,
    salespersonNo: "salespersonNo" as const,
    totalOrdered: "totalOrdered" as const,
}

/**
 * The data-grid cell entries for back orders view's items list.
 */
export const BackOrdersListsItemsDataGridCellKeys = {
    navigate: 'navigate' as const,
    print: 'print' as const,
    revertToQuote: 'revertToQuote' as const,
    orderNo: "orderNo" as const,
    customer: "customer" as const,
    partNo: "partNo" as const,
    submitDate: "submitDate" as const,
    unitPrice: "unitPrice" as const,
    orderQty: "orderQty" as const,
}

/**
 * The data-grid cell entries for invoices view's orders list.
 */
export const InvoicesListsOrdersDataGridCellKeys = {
    navigate: 'navigate' as const,
    print: 'print' as const,
    invoiceNo: 'invoiceNo' as const,
    customer: "customer" as const,
    invoiceDate: "invoiceDate" as const,
    customerPO: "customerPO" as const,
    salespersonNo: "salespersonNo" as const,
    totalOrdered: "total" as const,
    balance: "balance" as const,
    status: "status" as const,
}

/**
 * The data-grid cell entries for invoices view's items list.
 */
export const InvoicesListsItemsDataGridCellKeys = {
    navigate: 'navigate' as const,
    print: 'print' as const,
    orderNo: "orderNo" as const,
    customer: "customer" as const,
    partNo: "partNo" as const,
    submitDate: "submitDate" as const,
    unitPrice: "unitPrice" as const,
    orderQty: "orderQty" as const,
}

/**
 * The data-grid cell entries for invoices view's orders list.
 */
export const InvoicesListsReportDataGridCellKeys = {
    navigate: 'navigate' as const,
    print: 'print' as const,
    invoiceNo: 'invoiceNo' as const,
    customer: "customer" as const,
    invoiceDate: "invoiceDate" as const,
    customerPO: "customerPO" as const,
    salespersonNo: "salespersonNo" as const,
    avgCost: "avgCost" as const,
    discountAmount: "discountAmount" as const,
    appliedGiftCardAmount: "appliedGiftCardAmount" as const,
    subtotal: "subtotal" as const,
    totalOrdered: "total" as const,
    balance: "balance" as const,
    status: "status" as const,
}

/**

 * The data-grid cell entries for credits view's orders list.
 */
export const CreditsListsOrdersDataGridCellKeys = {
    navigate: 'navigate' as const,
    print: 'print' as const,
    invoiceNo: 'invoiceNo' as const,
    customer: "customer" as const,
    invoiceDate: "invoiceDate" as const,
    customerPO: "customerPO" as const,
    salespersonNo: "salespersonNo" as const,
    totalOrdered: "total" as const,
}

/**
 * The data-grid cell entries for credits view's items list.
 */
export const CreditsListsItemsDataGridCellKeys = {
    navigate: 'navigate' as const,
    print: 'print' as const,
    orderNo: "orderNo" as const,
    customer: "customer" as const,
    partNo: "partNo" as const,
    submitDate: "submitDate" as const,
    unitPrice: "unitPrice" as const,
    orderQty: "orderQty" as const,
}

/**
 * The data-grid cell entries for the vendors list view
 */
export const VendorsListDataGridCellKeys = {
    navigate: 'navigate',
    name: "name",
    code: 'code',
    email: 'email',
    phone: "phone",
    address: "address",
    city: 'city',
    province: 'province',
    postalCode: 'postalCode',
    status: 'status',
}

/**
 * The data-grid cell entries for the vendor's members list view
 */
export const VendorMembersDataGridCellKeys = {
    remove: 'remove',
    edit: 'edit',
    firstName: "firstName",
    lastName: 'lastName',
    email: "email",
    phone: "phone",
    role: 'role',
    position: 'position',
}

/**
 * Vendor purchase order list (shell) column keys.
 */
export const VendorPurchaseOrdersDataGridCellKeys = {
    navigate: 'navigate',
    print: 'print',
    orderNo: 'orderNo',
    date: 'date',
    status: 'status',
    total: 'total',
    currency: 'currency',
    vendor: 'vendor',
}

/**
 * Vendor purchase history list (shell) column keys.
 */
export const VendorPurchaseHistoryDataGridCellKeys = {
    navigate: 'navigate',
    print: 'print',
    historyNo: 'historyNo',
    date: 'date',
    status: 'status',
    total: 'total',
    currency: 'currency',
    vendor: 'vendor',
}

/**
 * Purchase history list report tab column keys (mirrors invoices report layout for purchasing).
 */
export const PurchaseHistoryListsReportDataGridCellKeys = {
    navigate: 'navigate',
    historyNo: 'historyNo',
    vendor: 'vendor',
    date: 'date',
    vendorPO: 'vendorPO',
    avgCost: 'avgCost',
    discountAmount: 'discountAmount',
    subtotal: 'subtotal',
    total: 'total',
    balance: 'balance',
    status: 'status',
}

/**
 * Vendor purchase line-items grid (shell) column keys.
 */
export const VendorPurchaseItemsDataGridCellKeys = {
    vendorPartNo: 'vendorPartNo',
    partNo: 'partNo',
    description: 'description',
    qty: 'qty',
    unitPrice: 'unitPrice',
    total: 'total',
    serials: 'serials',
}

/**
 * Purchase history single — products line grid columns.
 */
export const PurchaseHistorySingleItemsDataGridCellKeys = {
    partNo: 'partNo',
    vendorPartNo: 'vendorPartNo',
    description: 'description',
    comments: 'comments',
    orderQty: 'orderQty',
    cost: 'cost',
    extendedCost: 'extendedCost',
    serials: 'serials',
}

/**
 * Purchase history single — activity / logs grid columns.
 */
export const PurchaseHistorySingleLogsDataGridCellKeys = {
    loggedAt: 'loggedAt',
    user: 'user',
    action: 'action',
    details: 'details',
}

/**
 * The data-grid cell entries for the taxes' section of address card.
 */
export const AddressTaxesDataGridCellKeys = {
    tax: 'tax',
    rate: 'rate',
    exemptNo: 'exemptNo',
}

/**
 * The data-grid cell entries for the price matrices list view.
 */
export const PriceMatricesDataGridCellKeys = {
    remove: 'remove',
    edit: 'edit',
    type: 'type',
    target: 'target',
    change: 'change',
    basedOn: 'basedOn',
    startDate: 'startDate',
    endDate: 'endDate',
}

/**
 * The data-grid cell entries for credit card transactions summary list.
 */
export const CreditCardTransactionsSummaryDataGridCellKeys = {
    groupedBy: 'groupedBy' as const,
    receipt: 'receipt' as const,
    succeeded: 'Succeeded' as const,
    identifier: 'Identifier' as const,
    originalPayment: 'OriginalPayment' as const,
    type: 'Type' as const,
    amount: 'Amount' as const,
    authCode: 'AuthCode' as const,
    submitDateTime: 'SubmitDateTime' as const,
    providerSubmitDateTime: 'providerSubmitDateTime' as const,
    message: 'Message' as const,
    monerisInvoice: 'MonerisInvoice' as const,
    reference: 'Reference' as const,
    iso: 'Iso' as const,
    responseCode: 'ResponseCode' as const,
}

/**
 * The data-grid cell entries for moneris transactions list.
 */
export const MonerisTransactionsDataGridCellKeys = {
    receipt: 'receipt' as const,
    succeeded: 'Succeeded' as const,
    customer: 'Customer' as const,
    lastFourDigits: 'LastFourDigits' as const,
    identifier: 'ReceiptId' as const,
    originalPayment: 'OriginalPayment' as const,
    type: 'Type' as const,
    amount: 'Amount' as const,
    authCode: 'AuthCode' as const,
    submitDateTime: 'SubmitDateTime' as const,
    providerSubmitDateTime: 'ProviderSubmitDateTime' as const,
    message: 'Message' as const,
    monerisInvoice: 'MonerisInvoice' as const,
    reference: 'Reference' as const,
    iso: 'Iso' as const,
    responseCode: 'ResponseCode' as const,
}

/**
 * The data-grid cell entries for the following sections:
 * - user panel available-credits view
 * - pay-multi-invoice dialog's credit selection section
 * - add-credit-to-order dialog
 */
export const AvailableCreditsDataGridColumnNames = {
    transactionNo: 'transactionNo',
    reference: 'reference',
    date: 'date',
    type: 'type',
    credit: 'credit',
    balance: 'balance',
    select: 'select',
}

/**
 * The data-grid cell entries for bulk price change list
 */
export const BulkChangePriceDashboardDataGridCellKeys = {
    viewReports: 'viewReport' as const,
    submitDateTime: 'SubmitDateTime' as const,
    operator: 'operator' as const,
    status: 'status' as const,
    affectedParts: 'affectedParts' as const,
    changedAmount: 'changedAmount' as const,
    affectedPriceLevels: 'affectedPriceLevels' as const,
}

/**
 * The data-grid cell entries for bulk price change's products.
 * usages:
 * 1. part-selection section of new-bulk-price-change
 * 2. review-and-finalize section of new-bulk-price-change
 * 3. affected-products of bulk-price-change report
 */
export const BulkChangePriceAffectedProductsDataGridCellKeys = {
    index: 'Id' as const,
    partNumber: 'PartNumber' as const,
    mainCategory: 'MainCategory' as const,
    remove: 'remove' as const,
}

/**
 * The data-grid cell entries for new bulk price change's logs section
 */
export const BulkChangePriceAttemptedProductsDataGridCellKeys = {
    new: 'New' as const,
    attempt: 'attempt' as const,
    partNumber: 'partNumber' as const,
    category: 'category' as const,
    priceLevel: 'priceLevel' as const,
    oldPrice: 'oldPrice' as const,
    newPrice: 'newPrice' as const,
    status: 'status' as const,
    errorDescription: 'errorDescription' as const,
}

/**
 * The data-grid cell entries for the customers list view
 */
export const CustomersListDataGridCellKeys = {
    name: 'name',
    address: 'address',
    postalCode: 'postalCode',
    city: 'city',
    province: 'province',
    phone: 'phoneNumber',
    code: 'code',
    navigate: 'navigate',
}

/**
 * The data-grid cell entries for the customers list view
 */
export const CustomersMembersListDataGridCellKeys = {
    name: 'name',
    email: 'email',
    company: 'company',
    registerDate: 'registerDate',
    latestLogin: 'latestLoginDate',
    status: 'status',
    openInCrm: 'openInCRM',
    address: 'address',
    city: 'city',
    province: 'province',
    phone: 'phone',
    country: 'country',
    postalCode: 'postalCode',
    companyPhone: 'companyPhone',
    actionButton: 'actionButton'
}

/**
 * The data-grid cell entries for the operators list view
 */
export const OperatorsListDataGridCellKeys = {
    avatar: 'avatar',
    firstName: 'firstName',
    lastName: 'lastName',
    email: 'email',
    phone: 'phone',
    lastLoginDate: 'lastLoginDate',
    actions: 'actions',
}

/**
 * The data-grid cell entries for the operators groups list view
 */
export const OperatorsGroupsListDataGridCellKeys = {
    title: 'title',
    editDashboards: 'editDashboards',
    edit: 'edit',
    editAccessLevels: 'editAccessLevels'
}

/**
 * The data-grid cell entries for the surveys list view
 */
export const SurveysListDataGridCellKeys = {
    title: 'title',
    startDate: 'startDate',
    endDate: 'endDate',
    edit: "edit",
    preview: 'preview',
    delete: 'delete'
}

/**
 * The data-grid cell entries for the dynamic pages list view
 */
export const DynamicPagesListDataGridColumnNames = {
    remove: 'remove',
    open: 'open',
    title: 'title',
    route: 'route',
    isPublic: 'isPublic',
}


/**
 * The data-grid cell entries for the gift card transactions
 */
export const GiftCardTransactionsDataGridCellKeys = {
    submitDateTime: 'submitDateTime',
    type: 'type',
    amount: 'amount',
    balance: 'balance',
    userOrder: 'userOrder',
}

/**
 * The data-grid cell entries for the user general information company members
 */
export const UserGeneralInfoCompanyMembersDataGridCellKeys = {
    fullName: 'fullName',
    email: 'email',
    phone: 'phone',
    status: 'status',
    admin: 'admin',
    actions: 'actions',
}

/**
 * The data-grid cell entries for the part-support-request's information row.
 * usages:
 * 1. documentation section of upsert-part-support-request-dialog
 * 2. upsert-part-support-request-note-dialog
 * 3. assign-credit-to-part-support-request-dialog
 * 4. assign-vendor-credit-to-part-support-request-dialog
 */
export const PartSupportRequestInformationRowDataGridCellKeys = {
    rga: 'rga' as const,
    type: 'type' as const,
    status: 'status' as const,
    partNo: 'part' as const,
    customer: 'customer' as const,
    warehouseCode: 'warehouseCode' as const,
    vendorName: 'vendorName' as const,
    vendorCode: 'vendorCode' as const,
    invoiceNo: 'invoiceNo' as const,
    serialNo: 'serialNo' as const,
    quantity: 'quantity' as const,
}


/**
 * The data-grid cell entries for the operator dashboards list view.
 */
export const OperatorDashboardsDataGridCellKeys = {
    title: "title",
    dashboards: 'dashboards',
}

/**
 * The data-grid cell entries for the recent searches of a selected customer.
 * usages:
 * 1. lookup customers section
 * 2. quick order customers selection section
 */
export const CustomerAccountAndSearchesDetailsRecentSearchesDataGridCellKeys = {
    date: 'date',
    searchedBy: 'searchedBy',
    searchType: 'searchType',
    clickedPart: 'clickedPart',
}

/**
 * the data-grid cell entries for the vendor-selection of a part support request
 * usages:
 * 1. suggested vendors data-grid in the same component
 * 2. existing vendors data-grid in the same component
 */
export const VendorSelectionDataGridCellKeys = {
    code: 'code',
    name: 'name',
    select: 'select',
}

/**
 * the data-grid cell entries for the assign-user-to-customers dialog
 */
export const AssignUserToCustomerDataGridCellKeys = {
    name: 'name',
    country: 'country',
    province: 'province',
    city: 'city',
    address: 'address',
    postalCode: 'postalCode',
    code: 'code',
    select: 'select',
}

/**
 * the data-grid cell entries for the user-profile's price levles section.
 */
export const UserProfilePriceLevelsDataGridCellKeys = {
    action: 'action',
    industry: 'industry',
    category: 'category',
    priceLevel: 'priceLevel',
}

/**
 * the data-grid cell entries for the bulk import gift cards data grid
 */
export const BulkImportGiftCardsDataGridCellKeys = {
    selectBox: 'selectBox',
    cardNumber: 'cardNumber',
    amount: 'amount',
    category: 'category',
    errorMessage: 'errorMessage'
}

/**
 * Data grid cell keys for gift card categories
 */
export const GiftCardCategoriesDataGridCellKeys = {
    title: 'title',
    description: 'description',
    edit: 'edit',
    remove: 'remove',
}

/**
 * Data grid cell keys for price management dialog
 */
export const PriceManagementDialogDataGridCellKeys = {
    priceLevel: 'priceLevel',
    minPrice: 'minPrice',
    currentPrice: 'currentPrice'
}

/**
 * Data grid cell keys for warranty and return process settings applicability
 */
export const WarrantyAndReturnProcessSettingsApplicabilityDataGridCellsKeys = {
    remove: 'remove',
    partNo: 'partNo',
    dayLimit: 'dayLimit'
}

/**
 * Data grid cell keys for showing the new part support request part information
 */
export const NewPartSupportRequestPartInformationDataGridCellKeys = {
    title: 'title',
    price: 'price',
}

/**
 * Data grid cell keys for list of gift cards in the system
 */
export const OperatorGiftCardsDataGridCellKeys = {
    cardNumber: 'cardNumber',
    type: 'type',
    amount: 'amount',
    category: 'category',
    createdDate: 'createdDate',
    expiryDate: 'expiryDate',
    activeDate: 'activeDate',
    user: 'user',
    active: 'active',
    remove: 'remove',
    refill: 'refill',
}

/**
 * Data grid cell keys for list of drivers
 */
export const DriversListDataGridCellKeys = {
    firstName: 'firstName',
    lastName: 'lastName',
    phone: 'phone',
    email: 'email',
    status: 'status'
}

/**
 * Data grid cell keys for the fast connection list
 */
export const FastConnectionDataGridCellKeys = {
    partNumber: 'partNumber',
    amNumber: 'amNumber',
    oeNumber: 'oeNumber',
    tags: 'tags'
}

/**
 * The data-grid cell entries for the new lost search list view
 */
export const AccountReceivableDataGridCellKeys = {
    print: 'print',
    customer: 'customer',
    future: 'future',
    current: 'current',
    over30: 'over30',
    over60: 'over60',
    over90: 'over90',
    over120: 'over120',
    balance: 'balance',
    lastPaymentDate: 'lastPaymentDate',
    lastPaymentAmount: 'lastPaymentAmount',
    lastInvoiceDate: 'lastInvoiceDate',
    terms: 'terms',
    creditLimit: 'creditLimit',
    averageDaysToPay: 'averageDaysToPay',

}

/**
 * The data-grid cell entries for promotions list.
 */
export const PromotionsListDataGridCellKeys = {
    actionButton: 'actionButton' as const,
    code: 'code' as const,
    amount: 'amount' as const,
    used: 'used' as const,
    remaining: 'remaining' as const,
    giftCards: 'giftCards' as const,
    created: 'created' as const,
    expired: 'expired' as const,
    multipleUse: 'multipleUse' as const,
    applyAmount: 'applyAmount' as const,
}

/**
 * Data grid cell keys for list of promotion redeems
 */
export const SinglePromotionDataGridCellKeys = {
    customer: 'customer',
    amount: 'amount',
    redeemDateTime: 'redeemDateTime',
    cardNumber: 'cardNumber',
}

/**
 * Data grid cell keys for list of user promotion redeems
 */
export const UserPromotionRedeemListDataGridCellKeys = {
    code: 'code',
    amount: 'amount',
    redeemDateTime: 'redeemDateTime',
    cardNumber: 'cardNumber',
}

/**
 * The data-grid cell entries for decrease-serialized-product's availability's dialog.
 */
export const DecreaseSerializedProductAvailabilityDataGridCellKeys = {
    serial: 'serialNumber',
    cost: 'cost',
    receivedDate: 'receivedDate',
}

/**
 * The data-grid cell entries for modify reasons list dialog.
 */
export const ModifyReasonsListDataGridCellKeys = {
    code: 'code',
    reason: 'reason',
    operator: 'operator',
    addedDate: 'addedDate',
    defaultColumn: 'defaultColumn',

}

/**
 * The data-grid cell entries for inventory adjustment records.
 */
export const InventoryAdjustmentRecordsDataGridCellKeys = {
    view: 'view',
    code: 'Adjustment.Code',
    type: 'Adjustment.IsAdd',
    part: 'Part.PartNumber',
    quantity: 'OldQty',
    quantityChange: 'Qty',
    averageCost: 'AvgCost',
    cost: 'Cost',
    dateTime: 'Adjustment.SubmittedDatetime',
    warehouse: 'Warehouse.Code',
    reasonCode: 'Reason.Code',
    extendedCost: 'extendedCost',
    newQuantity: 'newQuantity',
    operator: 'operator',
    reason: 'reason',
    note: 'note'
}

/**
 * the data-grid cell entries for inventory adjustment list
 */
export const InventoryAdjustmentListDataGridCellKeys = {
    code: 'Code',
    type: 'IsAdd',
    dateTime: 'SubmittedDatetime',
    productCount: 'ProductCount',
    totalCount: 'TotalProductCount',
    totalCost: 'TotalCost',
    view: 'view',
    note: 'description',
    operator: 'submittedBy',
}

/**
 * the data-grid cell entries for inventory adjustment information's committed items list
 */
export const InventoryAdjustmentCommittedViewDataGridCellKeys = {
    partNumber: 'partNumber',
    category: 'category',
    quantity: 'quantity',
    quantityChange: 'quantityChange',
    newQuantity: 'newQuantity',
    cost: 'cost',
    averageCost: 'averageCost',
    warehouse: 'warehouse',
    reasonCode: 'reasonCode',
    extendedCost: 'extendedCost',
    reason: 'reason',
    note: 'note',
}

/**
 * the data-grid cell entries for bulk inventory adjustment's list
 */
export const BulkInventoryAdjustmentProductSelectionTableCellKeys = {
    partNumber: 'partNumber',
    category: 'category',
    quantity: 'quantity',
    averageCost: 'averageCost',
    extendedCost: 'extendedCost',
    minPrice: 'minPrice',
    reasonCode: 'reasonCode',
    note: 'note',
    warehouse: 'warehouse',
    currentAvailability: 'currentAvailability',
    cost: 'cost',
    actionButton: 'actionButton',
}
/**
 * The table cell keys for the shopping cart items
 */
export const ShoppingCartDataGridColumnKeys = {
    remove: 'remove',
    partImage: 'partImage',
    partNumber: 'partNumber',
    partPrice: 'partPrice',
    partQuantity: 'partQuantity',
}
/**
 * The table cell entries for connecting a credit to a part support requests table
 */
export const AssignEntityCreditsToPartSupportDataGridColumnNames = {
    number: 'number' as const,
    date: 'date' as const,
    poNumber: 'poNumber' as const,
    total: 'total' as const,
    select: 'select' as const,
}

/**
 * The table cell entries for the list view of shipping fees.
 */
export const ShippingFeesDataGridColumnNames = {
    invoiceNo: 'InvoiceNo',
    customer: 'Customer',
    eligibleForFreeShipping: 'FreeEligibility',
    estimatedFee: 'EstimatedFee',
    customerFee: 'CustomerFee',
    actualFee: 'ActualFee',
    estimatedDeliveryDate: 'EstimatedDeliveryDateTime',
    actualDeliveryDate: 'ActualDelivery',
    submittedDate: 'SubmittedDateTime',
    freightCompany: 'freightCompany',
    reason: 'reason',
    submittedBy: 'submittedBy',
    confirmedBy: 'confirmedBy',
}

/**
 * Data grid cell keys for list of freight companies.
 */
export const ShippingFeesFreightCompaniesListDataGridColumnNames = {
    code: 'code',
    title: 'title',
    method: 'method',
    noCarrierFee: 'noCarrierFee',
}

/**
 * Data grid cell keys for list of freight regions.
 */
export const ShippingFeesRegionsListDataGridColumnNames = {
    title: 'title',
    countries: 'countries',
    provinces: 'provinces',
    postalCodes: 'postalCodes',
}

/**
 * Data grid cell keys for list of region rates.
 */
export const RegionRatesListDataGridColumnNames = {
    region: 'region',
    rate: 'rate',
    remove: 'remove',
}

/**
 * Data grid cell keys for list of product flat rates (part rates).
 */
export const ProductFlatRatesListDataGridColumnNames = {
    partNumber: 'partNumber',
    rate: 'rate',
    remove: 'remove',
}

/**
 * The table cell entries for adding a part support request in the invoices table
 */
export const AddPartSupportRequestInvoicesDataGridColumnNames = {
    invoiceNo: 'invoiceNo' as const,
    date: 'invoiceDate' as const,
    price: 'unitPrice' as const,
    serialNo: 'serialNo' as const,
    selectedQty: 'orderQty' as const,
    select: 'select' as const,
}
/**
 * The table cell entries for adding a part support request in the warehouses table
 */
export const AddPartSupportRequestWarehousesDataGridColumnNames = {
    warehouse: 'warehouse' as const,
    partNo: 'partNo' as const,
    serialNo: 'serialNo' as const,
    selectedQty: 'selectedQty' as const,
    select: 'select' as const,
}
/**
 * The table cell entries for editing a part support request in the invoices table
 */
export const EditPartSupportRequestInvoicesDataGirdColumnNames = {
    invoiceNo: 'invoiceNo' as const,
    orderQty: 'orderQty' as const,
    date: 'invoiceDate' as const,
    price: 'unitPrice' as const,
    serialNo: 'serialNo' as const,
    selectedQty: 'selectedQty' as const,
    select: 'select' as const,
}
/**
 * The table cell entries for editing a part support request in the warehouses table
 */
export const EditPartSupportRequestWarehousesDataGridColumnNames = {
    warehouse: 'warehouse' as const,
    partNo: 'partNo' as const,
    serialNo: 'serialNo' as const,
    availableQty: 'availableQty' as const,
    selectedQty: 'selectedQty' as const,
    select: 'select' as const,
}
/**
 * The table cell entries for notification access levels view
 */
export const NotificationChannelAccessLevelDataGridColumnNames = {
    icon: 'icon' as const,
    name: 'name' as const,
    groups: 'groups' as const,
}
/**
 * The table cell entries for notification access levels view
 */
export const NotificationSubscriptionsDataGridColumnNames = {
    icon: 'icon' as const,
    channel: 'channel' as const,
    entities: 'entities' as const,
    status: 'status' as const,
}
/**
 * The table cell entries for product applications tab.
 */
export const ProductApplicationsDataGridColumns = {
    make: 'make' as const,
    model: 'model' as const,
    yearFrom: 'yearFrom' as const,
    yearTo: 'yearTo' as const,
    actions: 'actions' as const,
}
/**
 * The table cell entries for product technical files' assigned items
 */
export const ProductTechnicalFileAssignedItemsDataGridColumnNames = {
    partNo: 'partNo' as const,
    category: 'category' as const,
    toggle: 'toggle' as const,
}
/**
 * The table cell entries for product technical files shared links table.
 */
export const ProductTechnicalFileSharedLinksDataGridColumnNames = {
    name: 'name' as const,
    views: 'views' as const,
    link: 'link' as const,
    copy: 'copy' as const,
    remove: 'remove' as const,
}
/**
 * The table cell entries for product relation types table.
 */
export const ProductRelationTypesDataGridColumns = {
    title: 'title' as const,
    connectedParts: 'connectedParts' as const,
    suggestiveSelling: 'suggestiveSelling' as const,
    automaticallyAddedToCart: 'automaticallyAddedToCart' as const,
    actions: 'actions' as const,
}
/**
 * The table cell entries for main page edition type table.
 */
export const MainPageEditionDataGridColumnNames = {
    actions: "actions",
    name: "name",
    platform: "platform",
    submitDateTime: "submitDateTime",
    modifiedDateTime: "modifiedDateTime",
    submittedBy: "submittedBy",
    isLive: "isLive",
}
/**
 * The table cell entries for the suggestions list of product applications
 */
export const PartInformationApplicationSuggestionsDataGridColumnNames = {
    partNo: 'partNo',
    make: 'make',
    model: 'model',
    yearFrom: 'yearFrom',
    yearTo: 'yearTo',
    submittedAt: 'submittedAt',
    submittedBy: 'submittedBy',
    partner: 'partner',
    actions: 'actions',
}
/**
 * The table cell entries for the suggestions list of product technical info
 */
export const PartInformationTechnicalSuggestionsDataGridColumnNames = {
    partNo: 'partNo',
    title: 'title',
    type: 'type',
    defaultValues: 'defaultValues',
    description: 'description',
    submittedAt: 'submittedAt',
    submittedBy: 'submittedBy',
    partner: 'partner',
    actions: 'actions',
}

/**
 * The table cell entries for the tags list in tag management
 */
export const TagManagementListDataGridColumnNames = {
    view: 'view',
    title: "title",
    isVisible: "isVisible",
    isSearchable: 'isSearchable',
    isPublic: 'isPublic',
    changeIcon: 'change',
    delete: 'delete'
}
/**
 * The table cell entries for the connected parts to a tag
 */
export const TagConnectedPartsDataGridColumnNames = {
    partNumber: 'partNumber',
    description: 'description',
    deleteButton: 'deleteButton',
}
/**
 * The table cell entries for the purchases list view's orders tab.
 */
export const PurchasesViewOrdersDataGridColumnNames = {
    purchaseNo: "purchaseNo",
    vendor: "vendor",
    status: 'status',
    date: 'date',
    requiredDate: 'requiredDate',
    receivedDate: 'receivedDate',
    vendorPO: "vendorPO",
    total: "total",
}
/**
 * The table cell entries for the purchases list view's items tab.
 */
export const PurchasesViewItemsDataGridColumnNames = {
    purchaseNo: "purchaseNo",
    vendor: "vendor",
    status: 'status',
    partNo: "partNo",
    quantity: "quantity",
    unitPrice: "unitPrice",
    date: 'date',
    receivedDate: 'receivedDate',
    vendorPO: "vendorPO",
}
/**
 * The data-grid cell entries for free shipping management products' availability's dialog.
 */
export const FreeShippingFeesManagementProductsDataGridColumnNames = {
    partNo: 'partNo',
    threshold: "threshold",
}

/**
 * The data-grid cell entries for free shipping management regions' availability's dialog.
 */
export const FreeShippingFeesManagementRegionsDataGridColumnNames = {
    region: 'region',
    threshold: "threshold",
}

/**
 * The data-grid cell entries for free shipping management timelines' availability's dialog.
 */
export const FreeShippingFeesManagementTimelinesDataGridColumnNames = {
    timeline: 'timeline',
    threshold: "threshold",
}

/**
 * The data-grid cell entries for free shipping management companies' availability's dialog.
 */
export const FreeShippingFeesManagementCompaniesDataGridColumnNames = {
    company: 'company',
    threshold: "threshold",
}


/**
 * The data-grid cell entries for free shipping management categories' availability's dialog.
 */
export const FreeShippingFeesManagementCategoriesDataGridColumnNames = {
    industry: 'industry',
    category: 'company',
    threshold: "threshold",
}

/**
 * The data-grid cell entries for free shipping management priceLevels' availability's dialog.
 */
export const FreeShippingFeesManagementPriceLevelsDataGridColumnNames = {
    priceLevel: 'priceLevel',
    threshold: "threshold",
}


/**
 * The data-grid cell entries for free shipping management order simulation's dialog.
 */
export const FreeShippingFeesManagementOrderSimulationsDataGridColumnNames = {
    product: 'product',
    category: "category",
    quantity: "quantity",
    price: "price",
}


/**
 * The data-grid cell entries for free shipping management detached customers section.
 */
export const FreeShippingFeesManagementDetachedCustomersDataGridColumnNames = {
    navigate: 'navigate',
    remove: 'remove',
    customer: 'code',
    detachDateTime: 'detachDateTime',
}

/**
 * The data-grid cell entries for price matrices exceptional customers section.
 */
export const PriceMatricesManagementExceptionalCustomersDataGrid = {
    navigate: 'navigate',
    remove: 'remove',
    customer: 'customer',
    customPriceMatrices: 'customPriceMatrices',
}

/**
 * The data-grid cell entries for print labels view.
 */
export const PrintLabelsDataGridColumnNames = {
    remove: 'remove',
    partNo: 'partNo',
    serialNo: 'serialNo',
    repeatCount: 'repeatCount',
}

/**
 * The data-grid cell entries for order transactions section of order information view.
 */
export const OrderInformationTransactionsDataGridColumnNames = {
    receipt: 'receipt',
    groupBy: 'groupBy',
    code: 'code',
    transactionNo: 'transactionNo',
    date: 'date',
    type: 'type',
    debit: 'debit',
    credit: 'credit',
    authCode: 'authCode',
    referenceNo: 'referenceNo',
    service: 'service',
}

/**
 * The data-grid cell entries for the payment cards section of order information view.
 */
export const PayCustomerOnlinePaymentCardSelectionDataGridColumnNames = {
    default: 'default',
    provider: 'provider',
    type: 'type',
    cardNumber: 'cardNumber',
    expiryDate: 'expiryDate',
    select: 'select',
}

/**
 * The data-grid cell entries for the gift card section of order information view.
 */
export const AddGiftCardToOrderDataGridColumnNames = {
    cardNumber: 'cardNumber',
    category: 'category',
    expiryDate: 'expiryDate',
    amount: 'amount',
    select: 'select',
}

/**
 * The data-grid cell entries for the backorder generation section of order information view.
 */
export const BackOrderGenerationDataGridColumnNames = {
    partNo: 'partNo',
    backorderQty: 'backorderQty',
}

/**
 * The data-grid cell entries for the pay multi invoices dialog's invoices section.
 */
export const PayMultiInvoicesDialogInvoicesDataGridColumnNames = {
    invoiceNo: 'invoiceNo',
    customer: 'customer',
    submitDate: 'submitDate',
    poNo: 'poNo',
    salesPerson: 'salesPerson',
    total: 'total',
    balance: 'balance',
}


/**
 * The data-grid cell entries for the pay multi invoices dialog's summary section.
 */
export const PayMultipleInvoicesDialogSummaryDataGridColumnNames = {
    remove: 'remove',
    receipt: 'receipt',
    transactionNo: 'invoiceNo',
    date: 'customer',
    type: 'submitDate',
    referenceNo: 'poNo',
    debit: 'salesPerson',
    credit: 'total',
}

/**
 * The data-grid cell entries for credit information view's products section.
 */
export const CreditInformationViewProductsDataGridColumnNames = {
    partNo: 'partNo',
    warehouse: 'warehouse',
    description: 'description',
    discount: 'discount',
    quantity: 'quantity',
    unitPrice: 'unitPrice',
    totalPrice: 'totalPrice',
    committedQuantity: 'committedQuantity',
    comment: 'comment',
}

/**
 * The data-grid cell entries for invoice information view's products section.
 */
export const InvoiceInformationViewProductsDataGridColumnNames = {
    partNo: 'partNo',
    warehouse: 'warehouse',
    description: 'description',
    discount: 'discount',
    quantity: 'quantity',
    shipQuantity: 'shipQuantity',
    backOrderQuantity: 'backOrderQuantity',
    unitPrice: 'unitPrice',
    totalPrice: 'totalPrice',
    warrantyExpiration: 'warrantyExpiration',
    returnExpiration: 'returnExpiration',
    serials: 'serials',
    comment: 'comment',
}

/**
 * The data-grid cell entries for quote information view's products section.
 */
export const QuoteInformationViewProductsDataGridColumnNames = {
    remove: 'remove',
    warehouse: 'warehouse',
    partNo: 'partNo',
    description: 'description',
    discount: 'discount',
    quantity: 'quantity',
    availableQuantity: 'availableQuantity',
    unitPrice: 'unitPrice',
    totalPrice: 'totalPrice',
    comment: 'comment',
}


/**
 * The data-grid cell entries for sales order information view's products section.
 */
export const SalesOrderInformationViewProductsDataGridColumnNames = {
    remove: 'remove',
    warehouse: 'warehouse',
    partNo: 'partNo',
    description: 'description',
    discount: 'discount',
    quantity: 'quantity',
    backOrderQuantity: 'backOrderQuantity',
    unitPrice: 'unitPrice',
    totalPrice: 'totalPrice',
    availableQuantity: 'availableQuantity',
    committedQuantity: 'committedQuantity',
    comment: 'comment',
}

/**
 * The data-grid cell entries for the print catalog review dialog.
 */
export const PrintCatalogReviewDataGridColumnNames = {
    categoryColor: 'categoryColor',
    category: 'category',
    make: 'make',
    partNo: 'partNo',
    tags: 'tags',
}

/**
 * The data-grid cell entries for the print brochure review dialog.
 */
export const PrintBrochureReviewDataGridColumnNames = {
    order: 'order',
    note: 'note',
    remove: 'remove',
    partNo: 'partNo',
}

/**
 * The data-grid cell entries for the print packing list dialog.
 */
export const PrintPackingListDataGridColumnNames = {
    index: 'index',
    partNo: 'partNo',
    serialNo: 'serialNo',
}


/**
 * The data-grid cell entries for the customers list view
 */
export const MissingProductsListDataGridColumnNames = {
    partNo: 'partNo',
    category: 'category',
    import: 'import',
}


/**
 * The data-grid cell entries for the customers list view
 */
export const TransactionsTroubleShootingListDataGridColumnNames = {
    print: 'print',
    ignore: 'ignore',
    fix: 'fix',
    customer: 'customer',
    authCode: 'authCode',
    date: 'date',
    amount: 'amount',
    balance: 'balance',
    status: 'status',
    cardType: 'cardType',
    cardLast4Digits: 'cardLast4Digits',
    cardExpiry: 'cardExpiry',
    message: 'message',
}

/**
 * The data-grid cell entries for the invoices section of fix transaction dialog.
 */
export const FixTransactionInvoicesDataGridColumnNames = {
    invoiceNo: 'invoiceNo',
    date: 'date',
    amount: 'amount',
    balance: 'balance',
    applied: 'applied',
    remaining: 'remaining',
    action: 'action',
}

/**
 * The data-grid cell entries for missing transaction's section of fix transaction dialog.
 */
export const FixTransactionMissingTransactionDataGridColumnNames = {
    transactionNo: 'transactionNo',
    date: 'date',
    amount: 'amount',
    reference: 'reference',
}

/**
 * The data-grid cell entries for quick order summary's section.
 */
export const QuickOrderSummaryDataGridColumnNames = {
    status: 'status' as const,
    warehouse: 'warehouse' as const,
    partNumber: 'partNumber' as const,
    quantity: 'quantity' as const,
    price: 'price' as const,
    errorDescription: 'errorDescription' as const,
}

/**
 * Quick transfer items column names
 */
export const QuickTransferItemsColumnNames = {
    transferCode: 'TransferCode',
    partNumber: 'PartNumber',
    serialNo: 'serialNo',
    quantity: 'Quantity',
}

/**
 * The data-grid cell entries for the inventory transfer list.
 */
export const InventoryTransferListDataGridColumnNames = {
    navigate: 'navigate',
    code: 'code',
    status: 'status',
    submitDateTime: 'submitDateTime',
    modifiedDateTime: 'modifiedDateTime',
    requiredDate: 'requiredDate',
    fromWarehouseCode: 'fromWarehouseCode',
    toWarehouseCode: 'toWarehouseCode',
    totalPartCount: 'totalPartCount',
    totalRequestedQty: 'totalRequestedQty',
    totalScannedQty: 'totalScannedQty',
}


/**
 * The data-grid cell entries for the inventory transfer's items.
 */
export const InventoryTransferBatchInformationItemsDataGridColumnNames = {
    remove: 'remove',
    locateRequired: 'locateRequired',
    partNo: 'partNo',
    note: 'note',
    fromWarehouseAvailability: 'fromWarehouseAvailability',
    toWarehouseAvailability: 'toWarehouseAvailability',
    requestedQty: 'requestedQty',
    cost: 'cost',
    totalCost: 'totalCost',
    totalScannedCount: 'totalScannedCount',
    totalDeliveredCount: 'totalDeliveredCount',
    committedSerials: 'committedSerials',
}

/**
 * The data-grid cell entries for the inventory transfer's suggested items.
 */
export const InventoryTransferBatchInformationSuggestedItemsDataGridColumnNames = {
    partNo: 'partNo',
    fromWarehouseAvailability: 'fromWarehouseAvailability',
    toWarehouseAvailability: 'toWarehouseAvailability',
    minimumQty: 'minimumQty',
    suggestedQty: 'suggestedQty',
    qty: 'qty',
    add: 'add',
}

/**
 * transfer batch information logs data grid column names
 */
export const InventoryTransferBatchInformationLogsDataGridColumnNames = {
    operatorFirstName: 'operatorFirstName',
    operatorLastName: 'operatorLastName',
    action: 'action',
    partNo: 'partNo',
    serialNo: 'serialNo',
    quantity: 'quantity',
    dateTime: 'dateTime',
    description: 'description',
}

/**
 * Post transfer view mismatched serials data grid column names
 */
export const PostTransferViewMismatchedSerialsDataGridColumnNames = {
    partNo: 'partNo',
    fromWarehouse: 'fromWarehouse',
    toWarehouse: 'toWarehouse',
    requestedQty: 'requestedQty',
    correctlyDeliveredItems: 'correctlyDeliveredItems',
    incorrectlyDeliveredItems: 'incorrectlyDeliveredItems',
    finalizedQty: 'finalizedQty',
    finalizedSerialNos: 'finalizedSerialNos',
    returnedSerialNos: 'returnedSerialNos',
    movedToNextBatch: 'movedToNextBatch',
}

/**
 * post transfer view mismatched quantities data grid column names
 */
export const PostTransferViewMismatchedQuantitiesDataGridColumnNames = {
    partNo: 'partNo',
    fromWarehouse: 'fromWarehouse',
    toWarehouse: 'toWarehouse',
    requestedQty: 'requestedQty',
    deliveredQty: 'deliveredQty',
    finalizedQty: 'finalizedQty',
    returnedQty: 'returnedQty',
    movedToNextBatch: 'movedToNextBatch',
}

/**
 * Tax management list data grid column names
 */
export const TaxManagementListDataGridColumnNames = {
    edit: 'edit',
    remove: 'remove',
    code: "code",
    name: "name",
    rate: "rate",
    isProvincial: "isProvincial",
}

/**
 * the data-grid cell entries for the import adjustment dialog
 */
export const importAdjustmentDialogDataGridColumnNames = {
    errorMessage: 'errorMessage',
    warehouse: 'warehouse',
    partNumber: 'partNumber',
    category: 'category',
    quantity: 'quantity',
    cost: 'cost',
    extendedCost: 'extendedCost',
    serialNos: 'serialNos',
}

/**
 * Data grid cell keys for list of freight regions.
 */
export const SalesPersonsAccessLevelsDataGridColumnNames = {
    name: 'name',
    code: 'code',
    operatorName: 'operatorName',
    submittedDateTime: 'submittedDateTime',
    quoteCount: 'quoteCount',
    salesOrderCount: 'salesOrderCount',
    invoiceCount: 'invoiceCount',
    accessToPriceChange: 'accessToPriceChange',
    eligiblePriceChangePct: 'eligiblePriceChangePct',
    warehouses: 'warehouses',
    actions: 'actions',
}

/**
 * Data grid column names for refund transactions.
 */
export const refundTransactionsDataGridColumns = {
    authorizationCode: 'authorizationCode',
    transactionTypeDescription: 'transactionTypeDescription',
    amount: 'amount',
    isDebit: 'isDebit',
    transactionNo: 'transactionNo',
    submittedDate: 'submittedDate',
    service: 'service',
    isSubmitted: 'isSubmitted',
    status: 'status',
    select: 'select',
}

/**
 * Data grid column names for issue credit from invoice item selection.
 */
export const issueCreditFromInvoiceItemSelectionDataGridColumnNames = {
    status: 'status',
    partNo: 'partNo',
    warehouse: 'warehouse',
    quantity: 'quantity',
    unitPrice: 'unitPrice',
    totalPrice: 'totalPrice',
    serialNoOrQuantity: 'serialNoOrQuantity',
    groupBy: 'groupBy',
    selection: 'selection',
    message: 'message',
}

/**
 * Customer credit list data grid column names
 */
export const CreateWarehouseForOrderItemsDataGridColumnNames = {
    partNo: 'partNo',
    warehouse: 'warehouse',
    action: 'action',
}

/**
 * The data-grid cell entries for the logs of the lookup analytics view
 */
export const LookupAnalyticsLogsDataGridColumnNames = {
    navigate: 'navigate',
    filters: 'filters',
    keyword: 'Keyword',
    user: 'user',
    customer: 'customer',
    operator: 'operator',
    clickedPart: 'PartClickedId',
    resultCount: 'FoundedItem',
    submitDateTime: 'SubmitDateTime',
    lostSearchDescription: 'LostSearchDescription',
    hasBeenReviewed: 'HasBeenReviewed',
    reviewNote: 'ReviewNote',
    repeatCount: 'RepeatCount',
}

export const ProductOnPurchaseListDataGridColumnNames = {
    poNo: 'partNo',
    vendorCode: 'vendorCode',
    qty: 'qty',
    eta: 'eta',
    shipVia: 'shipVia',
    shipTo: 'shipTo',
    trackingNo: 'trackingNo',
    note: 'note',
    action: 'action',
}

export const ProductOnBackorderListDataGridColumnNames = {
    orderNo: 'orderNo',
    createdDate: 'createdDate',
    customer: 'customer',
    qty: 'qty',
    action: 'action',
}

/**
 * The data-grid cell entries for the products data grid view
 */
export const ProductsDataGridViewColumnNames = {
    actions: 'actions',
    images: 'images',
    partNumber: 'partNumber',
    category: 'category',
    availability: 'availability',
    variants: 'variants',
    additionalProperties: 'additionalProperties',
    codes: 'codes',
    tags: 'tags',
}


/**
 * Data grid cell keys for list of freight regions.
 */
export const TerritoryManagementDataGridColumnNames = {
    code: 'code',
    name: 'name',
    description: 'description',
}


/**
 * The data-grid cell entries for Notes lists of ncr (notes page)
 */
export const ProductDimensionManagementDataGridColumnNames = {
    vendorCode: 'vendorCode',
    height: 'height',
    width: 'width',
    length: 'length',
    weight: 'weight',
    comment: 'comment',
    actions: 'actions',
};

export const OrderDimensionsDataGridColumnNames = {
    clear: 'clear',
    container: 'container',
    partNo: 'partNo',
    serialNo: 'serialNo',
    qty: 'qty',
    height: 'height',
    width: 'width',
    length: 'length',
    weight: 'weight',
    volume: 'volume',
    vendorCode: 'vendorCode',
    comment: 'comment',
    description: 'description',
    sizeOptions: 'sizeOptions',
}

export const ProductInformationVendorsDataGridColumnNames = {
    remove: "remove",
    edit: "edit",
    vendorCode: 'vendorCode',
    vendorPartNumber: 'vendorPartNumber',
    vendorPrice: 'vendorPrice',
    startDateTime: 'startDateTime',
    endDateTime: 'endDateTime',
    isCurrentlyActive: 'isCurrentlyActive',
    submitter: 'submitter',
    submitDateTime: 'submitDateTime',
    updater: 'updater',
    updateDateTime: 'updateDateTime',
}

/**
 * Vendor-scoped products list (vendor parts offered by one vendor).
 */
export const VendorProductsDataGridColumnNames = {
    remove: 'remove',
    edit: 'edit',
    partNo: 'partNo',
    vendorPartNumber: 'vendorPartNumber',
    vendorPrice: 'vendorPrice',
    startDateTime: 'startDateTime',
    endDateTime: 'endDateTime',
    isCurrentlyActive: 'isCurrentlyActive',
    submitter: 'submitter',
    submitDateTime: 'submitDateTime',
    updater: 'updater',
    updateDateTime: 'updateDateTime',
}

export const AccountReceivableTransactionsDataGridColumnNames = {
    receipt: 'receipt',
    transactionNo: 'transactionNo',
    date: 'date',
    debit: 'debit',
    credit: 'credit',
    balance: 'balance',
    linkBalance: 'linkBalance',
    termsCode: 'termsCode',
    customerPO: 'customerPO',
    referenceNo: 'referenceNo',
    type: 'type',
    memo: 'memo',
}

/** BizPoint — Pointing System / Loyalty */
export const BizPointLoyaltyCustomersDataGridColumnNames = {
    customerNo: 'customerNo',
    name: 'name',
    contact: 'contact',
    confirmedBiz: 'confirmedBiz',
    frozen: 'frozen',
    walletStatus: 'walletStatus',
    actions: 'actions',
} as const;

export const BizPointLoyaltyRulesDataGridColumnNames = {
    name: 'name',
    conditions: 'conditions',
    formula: 'formula',
    dailyCap: 'dailyCap',
    monthlyCap: 'monthlyCap',
    version: 'version',
    status: 'status',
    actions: 'actions',
} as const;

export const BizPointLoyaltyPurchasesDataGridColumnNames = {
    ref: 'ref',
    date: 'date',
    amount: 'amount',
    biz: 'biz',
    status: 'status',
} as const;

export const BizPointLoyaltyDistributionDataGridColumnNames = {
    date: 'date',
    customer: 'customer',
    rule: 'rule',
    biz: 'biz',
    status: 'status',
} as const;

/** BizPoint — Admin */
export const BizPointAdminAuditLogDataGridColumnNames = {
    when: 'when',
    who: 'who',
    what: 'what',
    why: 'why',
} as const;

export const BizPointAdminPurchaseConfirmDataGridColumnNames = {
    ref: 'ref',
    business: 'business',
    date: 'date',
    amount: 'amount',
    biz: 'biz',
    eftRef: 'eftRef',
    actions: 'actions',
} as const;

export const BizPointAdminBusinessConfigDataGridColumnNames = {
    business: 'business',
    currency: 'currency',
    rateBizPer100: 'rateBizPer100',
    redeemPer900: 'redeemPer900',
    freezeDays: 'freezeDays',
    tier: 'tier',
    actions: 'actions',
} as const;

export const BizPointAdminLiabilityDataGridColumnNames = {
    business: 'business',
    outstanding: 'outstanding',
    undistributed: 'undistributed',
    inFreeze: 'inFreeze',
} as const;

export const BizPointAdminReviewQueueDataGridColumnNames = {
    wallet: 'wallet',
    rule: 'rule',
    biz: 'biz',
    reason: 'reason',
    age: 'age',
    actions: 'actions',
} as const;

/** Lookup — Competitor price reports */
export const CompetitorPriceReportsDataGridColumnNames = {
    operator: 'operatorName',
    partNumber: 'partNumber',
    price: 'price',
    competitorPrice: 'competitorPrice',
    competitor: 'competitorName',
    submitDateTime: 'submitDateTime',
    customer: 'customerName',
    priceLevel: 'priceLevelTitle',
    checked: 'isChecked',
    checkedDateTime: 'checkedDateTime',
    actions: 'actions',
} as const;

/** Support — Contact Us Messages */
export const ContactUsMessagesDataGridColumnNames = {
    name: 'name',
    subject: 'subject',
    phone: 'phone',
    email: 'email',
    submitDateTime: 'submitDateTime',
    isRead: 'isView',
    actions: 'actions',
} as const;
